import { StyleSheet } from 'aphrodite';
import { SPACE } from '../../../../components-v2/Theme/theme';

export const includeMeetingGuestsCheckboxStyles = StyleSheet.create({
	field: {
		marginTop: SPACE[16],
	},
});
